import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import "react-tabs/style/react-tabs.css";
import { useSelector, useDispatch } from "react-redux";

import {
  paymentType,
  profileTabConstants,
  roles,
  translationConstants,
} from "../../../../constants";

import GeneralTab from "./Tabs/GeneralTab";
import CertificatesTab from "./Tabs/CertificatesTab";
import PaymentTab from "./Tabs/PaymentTab";
import { getUserPayload } from "../../../../system";
import { paymentActions } from "../../../../redux/actions";

const Profile = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const userData = getUserPayload();

  const profileData = useSelector((state) => state.ProfileReducer.profileData);

  const [tabFromURL, setTabFromURL] = useState(
    new URLSearchParams(location?.search)?.get("tab")
  );
  const [key, setKey] = useState(profileTabConstants.PROFILE);

  useEffect(() => {
    if (tabFromURL) {
      if (
        userData?.user.role === roles.GeneralUser ||
        (userData?.user?.role === roles.VerifiedUser &&
          !userData?.practionerStatus)
      ) {
        setKey(profileTabConstants.PAYMENT.verified);
      } else {
        setKey(profileTabConstants.PAYMENT.sailor);
      }
      setTabFromURL(null);
    }
    /*eslint-disable-next-line */
  }, [tabFromURL]);

  useEffect(() => {
    if (userData?.user?.role === roles.FreelanceInstructor) {
      dispatch(
        paymentActions.paymentHistoryStats({
          systemUserId: userData?.user?.id,
          paymentType: paymentType.Freelance,
        })
      );
    }
    /*eslint-disable-next-line */
  }, []);

  return (
    <div className="container">
      <div className="user-profile">
        <Tabs
          id="user-profile-controller"
          selectedIndex={key}
          onSelect={(k) => setKey(k)}
        >
          <TabList>
            <Tab eventKey={profileTabConstants.PROFILE}>
              {t(translationConstants.GENERAL_TAB)}
            </Tab>

            {(profileData?.practionerCertificates?.length > 0 ||
              profileData?.instructorCertificates?.length > 0 ||
              profileData?.practitionerDigitalCertificates?.length > 0) && (
              <Tab eventKey={profileTabConstants.QUALIFICATIONS}>
                {t(translationConstants.CERTIFICATES_TAB)}
              </Tab>
            )}

            <Tab eventKey={profileTabConstants.PAYMENT.sailor}>
              {t(translationConstants.PAYMENT)}
            </Tab>
          </TabList>

          <TabPanel>
            <GeneralTab generalClassName={"general-tab"} />
          </TabPanel>

          {(profileData?.practionerCertificates?.length > 0 ||
            profileData?.instructorCertificates?.length > 0 ||
            profileData?.practitionerDigitalCertificates?.length > 0) && (
            <TabPanel>
              <CertificatesTab />
            </TabPanel>
          )}

          <TabPanel>
            <PaymentTab />
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
};

export default Profile;
